import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-3" }, "Users", -1)
const _hoisted_3 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_6 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "alert alert-primary",
    role: "alert"
  }, "No Users found")
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "row mt-3 py-3 border-bottom border-top bg-light" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "row mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Email")
], -1)
const _hoisted_15 = { class: "col-10" }
const _hoisted_16 = { class: "row mt-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "First Name")
], -1)
const _hoisted_18 = { class: "col-10" }
const _hoisted_19 = { class: "row mt-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Surname")
], -1)
const _hoisted_21 = { class: "col-10" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-12 d-flex justify-content-end mt-3" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "row pt-3" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = {
  key: 0,
  class: "d-flex mt-5 justify-content-center align-items-center"
}
const _hoisted_28 = {
  key: 1,
  class: "w-100"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Email")
  ])
], -1)
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col d-flex justify-content-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_VPagination = _resolveComponent("VPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.error != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.error), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.error == '' && !_ctx.loading && _ctx.users.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.selectedUser.id !== "" ? "Edit" : "Add New") + " User", 1)
          ]),
          (_ctx.selectedUser.id !== '')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                style: {"cursor":"pointer"},
                title: "Stop editing",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.unselectUser()))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "mr-3",
                  icon: ['fas', 'times']
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              required: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedUser.email) = $event))
            }, null, 512), [
              [_vModelText, _ctx.selectedUser.email]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              required: "",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedUser.forename) = $event))
            }, null, 512), [
              [_vModelText, _ctx.selectedUser.forename]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              required: "",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedUser.surname) = $event))
            }, null, 512), [
              [_vModelText, _ctx.selectedUser.surname]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_ctx.selectedUser.id === '')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addUser && _ctx.addUser(...args)), ["prevent"])),
                  disabled: !_ctx.validateUser()
                }, " Add User ", 8, _hoisted_24))
              : _createCommentVNode("", true),
            (_ctx.selectedUser.id !== '')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-danger mr-1",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.deleteUser(_ctx.selectedUser.id)), ["prevent"]))
                }, " Lockout User "))
              : _createCommentVNode("", true),
            (_ctx.selectedUser.id !== '')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-primary",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateUser && _ctx.updateUser(...args)), ["prevent"]))
                }, " Update User "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        (_ctx.loading && _ctx.error.length != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createVNode(_component_font_awesome_icon, {
                class: "text-primary",
                icon: ['fas', 'spinner'],
                size: "lg",
                spin: ""
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loading && _ctx.users.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (usr) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: usr.id,
                    class: _normalizeClass(usr.id === _ctx.user.id ? 'selected-row' : ''),
                    onClick: _withModifiers(($event: any) => (_ctx.selectedUser = { ...usr }), ["prevent"])
                  }, [
                    _createElementVNode("td", null, _toDisplayString(usr.forename + " " + usr.surname), 1),
                    _createElementVNode("td", null, _toDisplayString(usr.email), 1)
                  ], 10, _hoisted_30))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_VPagination, {
              pagination: _ctx.usersPagination,
              "onUpdate:pagination": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.usersPagination) = $event)),
              onPageChanged: _cache[8] || (_cache[8] = (page) => (_ctx.currentPage = page))
            }, null, 8, ["pagination"])
          ])
        ])
      ])
    ])
  ]))
}